ui-bank-search-mobile-slide {
  /* stylelint-disable */
  display: block;
  text-align: center;
  /* stylelint-enable */
}
